<template>
  <div>
    <p>Get detailed insights into your endpoint performance with real-time metrics:</p>
    <ul>
      <li><strong>Throughput</strong> - Messages processed per second for each endpoint</li>
      <li><strong>Processing time</strong> - Average time to handle each message type</li>
      <li><strong>Queue length</strong> - Current number of messages waiting to be processed</li>
      <li><strong>Critical time</strong> - Total time from message send to processing completion</li>
    </ul>
  </div>
</template>
